export default __webpack_public_path__ + "static/media/logo__technology__flutter.9478f9e3.png";